import React from "react";

import Update from "@material-ui/icons/Update";
import Power from "@material-ui/icons/Power";
import PowerOff from "@material-ui/icons/PowerOff";
import Secure from "@material-ui/icons/Security";


function TableUpdateUsers(props) {
  return (
    <div className="content-line">
      <div className="line line-100">
        <table className="table-results">
          <tbody>
            <tr>
              <th className="table-column-name">Nombre</th>
              <th className="table-column-user">Usuario</th>
              <th className="table-column-doc">Documento</th>
              <th className="table-column-charge">Cargo</th>
              <th className="table-column-depen">Dependencia</th>
              <th className="table-column-actions">Acciones</th>
            </tr>
            {props.content.map((item, index) => (
              <tr key={"row-table-hg ash-" + index}>
                <td className="table-column-name">
                  {item.nombres + " " + item.apellidos}
                </td>
                <td className="table-column-user">{item.user}</td>
                <td className="table-column-doc">{item.numeroDocumento}</td>
                <td className="table-column-charge">{item.cargo}</td>
                <td className="table-column-depen">{item.dependencia}</td>
                <td className="table-column-actions">
                  <div
                    className="table-buttom gray-background-color"
                    onClick={() => props.update(item)}
                  >
                    <Update
                      style={{ color: "white" }}
                      titleAccess="Actualizar"
                    />
                  </div>
                  <div
                    className="table-buttom primary-background-color"
                    onClick={() => props.changePassword(item)}
                  >
                    <Secure
                      style={{ color: "white" }}
                      titleAccess="Cambiar clave"
                    />
                  </div>
                  {!!item.active ? (
                    <div
                      className="table-buttom secondary-background-color"
                      onClick={() => props.activate(item)} 
                    >
                      {" "}
                      <Power
                        style={{ color: "white" }}
                        titleAccess="Desactivar"
                      />
                    </div>
                  ) : (
                    <div
                      className="table-buttom gray-background-color"
                      onClick={() => props.activate(item)}
                    >
                      {" "}
                      <PowerOff
                        style={{ color: "black" }}
                        titleAccess="Activar"
                      />
                    </div>
                  )}
                  {/* <img src={ContinueIcon} alt="tal" className="image-action clickable" onClick={props.handlerAction} />
                                        <img src={DeleteIcon} alt="tal" className="image-action clickable" onClick={props.handlerAction} />
                                        <img src={FileIcon} alt="tal" className="image-action clickable" onClick={props.handlerAction} /> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TableUpdateUsers;
